var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.style)},[_c('div',{staticClass:"box",class:_vm.levelText},[_vm._v(" "+_vm._s(_vm.levelText)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }